/* Maverick rental 3-day minimum (preview theme). */
(function () {
  var R = window.MaverickRental; if (!R) return;
  var MIN = R.min || 3;
  var rentalKeys = {}; var cartQty = {};

  function isRentalItem(it) {
    var t = (it.product_type || '').trim();
    return (t === 'Rental' || t === 'Rentals') && it.handle !== R.depositHandle;
  }

  /* ---------- Product page ---------- */
  function setupProduct() {
    if (!R.isRentalProduct) return;
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      if (input.dataset.mvr) return; input.dataset.mvr = '1';
      input.setAttribute('min', MIN);
      if (!input.value || parseInt(input.value, 10) < MIN) input.value = MIN;
      var qs = input.closest('quantity-selector');
      if (qs) { qs.minValue = MIN; qs.style.setProperty('--digit-count', String(input.value).length + 'ch'); }
      var label = input.id && document.querySelector('label[for="' + input.id + '"]');
      if (!label) { var wrap = input.closest('.product-block, .product__quantity, .js-qty__wrapper, div'); label = wrap && wrap.parentElement && wrap.parentElement.querySelector('label'); }
      if (label) label.textContent = R.label;
      var host = qs || input.parentElement;
      if (host && !host.parentElement.querySelector('.mvr-note')) {
        var n = document.createElement('p'); n.className = 'mvr-note'; n.textContent = R.note;
        host.insertAdjacentElement('afterend', n);
      }
      input.addEventListener('change', function () { if (parseInt(input.value, 10) < MIN || isNaN(parseInt(input.value, 10))) input.value = MIN; });
    });
    document.querySelectorAll('form[action*="/cart/add"] .shopify-payment-button, form[action*="/cart/add"] [data-shopify="payment-button"]').forEach(function (el) { el.style.display = 'none'; });
  }
  function productQty(form) {
    var inp = form.querySelector('input[name="quantity"]') || (form.id && document.querySelector('input[name="quantity"][form="' + form.id + '"]')) || document.querySelector('input[name="quantity"]');
    return inp ? parseInt(inp.value, 10) : 1;
  }
  function guardAdd(e) {
    if (!R.isRentalProduct) return;
    var form = e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    if (e.type === 'click' && !e.target.closest('[name="add"], [data-add-to-cart], button[type="submit"]')) return;
    var q = productQty(form);
    if (!(q >= MIN)) {
      e.preventDefault(); e.stopImmediatePropagation();
      var inp = document.querySelector('input[name="quantity"]'); if (inp) inp.value = MIN;
      notice(form, R.blockMsg);
    }
  }
  document.addEventListener('submit', guardAdd, true);
  document.addEventListener('click', guardAdd, true);

  /* ---------- Cart page and drawer ---------- */
  function notice(scope, msg) {
    var el = scope.querySelector('.mvr-notice');
    if (!el) { el = document.createElement('div'); el.className = 'mvr-notice'; el.setAttribute('role', 'alert'); scope.insertBefore(el, scope.firstChild); }
    el.textContent = msg;
  }
  function lineInput(key) { return document.querySelectorAll('input[data-id="' + key + '"], quantity-selector[key="' + key + '"] input'); }

  var bumping = false;
  function bump(key) {
    if (bumping) return; bumping = true;
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: MIN }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build')); // Impulse drawer refresh
        document.querySelectorAll('#CartDrawerForm, form[action*="/cart"]:not([action*="/cart/add"])').forEach(function (f) { notice(f, R.bumpMsg); });
        if (/\/cart\/?$/.test(location.pathname)) setTimeout(function () { location.reload(); }, 600);
      }).finally(function () { bumping = false; setTimeout(scan, 400); });
  }

  function applyCart() {
    var under = false;
    Object.keys(rentalKeys).forEach(function (key) {
      lineInput(key).forEach(function (inp) {
        inp.setAttribute('min', MIN);
        var qs = inp.closest('quantity-selector'); if (qs) qs.minValue = MIN;
      });
      if (cartQty[key] < MIN) under = true;
    });
    var forms = document.querySelectorAll('#CartDrawerForm, form[action*="/cart"]:not([action*="/cart/add"])');
    forms.forEach(function (f) {
      f.querySelectorAll('[name="checkout"], .additional-checkout-buttons, a[href*="/checkout"]').forEach(function (b) {
        if (under) { b.classList.add('mvr-checkout-disabled'); if (b.tagName === 'BUTTON') b.disabled = true; }
        else { b.classList.remove('mvr-checkout-disabled'); if (b.tagName === 'BUTTON') b.disabled = false; }
      });
      if (under) notice(f, R.blockMsg); else { var n = f.querySelector('.mvr-notice'); if (n && n.textContent === R.blockMsg) n.remove(); }
    });
    if (under) Object.keys(rentalKeys).some(function (k) { if (cartQty[k] < MIN) { bump(k); return true; } });
  }

  var scanning = null;
  function scan() {
    if (scanning) return scanning;
    scanning = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      rentalKeys = {}; cartQty = {};
      (cart.items || []).forEach(function (it) { if (isRentalItem(it)) { rentalKeys[it.key] = 1; cartQty[it.key] = it.quantity; } });
      applyCart();
    }).catch(function () {}).finally(function () { scanning = null; });
    return scanning;
  }

  /* Block minus below 3 on rental lines (capture phase, before theme handlers). */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('.js-qty__adjust--minus, .element-quantity-selector__button--minus');
    if (!minus) return;
    var wrap = minus.closest('.js-qty__wrapper, quantity-selector');
    var inp = wrap && wrap.querySelector('input');
    if (!inp) return;
    var key = inp.getAttribute('data-id') || (wrap.getAttribute && wrap.getAttribute('key'));
    var rental = key ? rentalKeys[key] : (R.isRentalProduct && inp.name === 'quantity');
    if (rental && parseInt(inp.value, 10) <= MIN) {
      e.preventDefault(); e.stopImmediatePropagation(); inp.value = MIN;
      var scope = minus.closest('#CartDrawerForm, form'); if (scope && key) notice(scope, R.bumpMsg);
    }
  }, true);
  /* Typed quantities on rental lines. */
  document.addEventListener('change', function (e) {
    var inp = e.target; if (!inp.matches || !inp.matches('input[data-id]')) return;
    var key = inp.getAttribute('data-id');
    if (rentalKeys[key] && !(parseInt(inp.value, 10) >= MIN) && inp.value !== '0') { inp.value = MIN; }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('#CartDrawerForm, form[action*="/cart"]:not([action*="/cart/add"])') && e.submitter && e.submitter.name === 'checkout') {
      var under = Object.keys(rentalKeys).some(function (k) { return cartQty[k] < MIN; });
      if (under) { e.preventDefault(); e.stopImmediatePropagation(); notice(f, R.blockMsg); }
    }
  }, true);

  /* Re-check whenever cart markup changes (drawer re-renders). */
  var t; var mo = new MutationObserver(function (muts) {
    if (muts.every(function (m) { return m.target.closest && m.target.closest('.mvr-notice'); })) return;
    clearTimeout(t); t = setTimeout(function () { setupProduct(); if (document.querySelector('.cart__item, #CartDrawerForm')) scan(); }, 300);
  });
  function init() { setupProduct(); scan(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();